import Link from "next/link";
import React from "react";
const AuthButton = ({
  text,
  transparent,
  textColor,
  url,
  target,
  type,
  textWeightMedium,
  unShrinkable,
  textSizeBtnClass = "text-[14px]",
}: {
  text: string;
  transparent?: boolean;
  textColor?: string;
  url: string;
  target?: string;
  type?: string;
  textWeightMedium?: boolean;
  unShrinkable?: boolean;
  textSizeBtnClass?: string;
}) => {
  return (
    <div>
      {type === "integrationButton" ? (
        <a
          className={`flex w-fit items-center rounded-[4px] border-[0.5px] border-solid px-3 py-[10px] duration-200 ease-in-out ${
            transparent ? "border-outlineBorder" : "border-transparent"
          } ${
            transparent
              ? "font-inte bg-transparent"
              : "bg-white opacity-80 hover:opacity-100"
          } ${textWeightMedium ? "font-medium" : "font-semibold"} ${textSizeBtnClass} ${textColor}`}
          href={url}
          target={target === "none" ? undefined : "_blank"}
        >
          {text}
        </a>
      ) : type === "gradientBgButton" ? (
        <Link
          className={`${textWeightMedium ? "font-medium" : "font-semibold"} ${textSizeBtnClass} ${unShrinkable ? "flex-shrink-0" : ""} gradientBgBtn flex w-fit items-center rounded-[4px] px-3 py-[10px] text-white duration-200 ease-in-out lg:px-8 lg:py-2`}
          href={url}
          target={target === "none" ? undefined : "_blank"}
        >
          {text}
        </Link>
      ) : (
        <Link
          className={`flex w-fit items-center rounded-[4px] border-[0.5px] border-solid px-4 py-[10px] duration-200 ease-in-out ${
            transparent ? "border-outlineBorder" : "border-transparent"
          } ${
            transparent
              ? "bg-transparent"
              : "bg-white opacity-80 hover:opacity-100"
          } ${textWeightMedium ? "font-medium" : "font-semibold"} ${textColor} ${textSizeBtnClass} ${unShrinkable ? "flex-shrink-0" : ""}`}
          href={url}
          target={target === "none" ? undefined : "_blank"}
        >
          {text}
        </Link>
      )}
    </div>
  );
};

export default AuthButton;
